import WarningIcon from './../../assets/icons/warning-icon.svg?react';

interface NoItemsFoundProps {
  message?: string;
}

export default function NoItemsFound({
  message = 'Data does not exist',
}: NoItemsFoundProps) {
  return (
    <div className="my-4 flex min-h-120 flex-col items-center justify-center gap-4 text-center">
      <WarningIcon className="[&>g>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />

      <p className="max-w-lg text-2xl">{message}</p>
    </div>
  );
}
